require('./stockExchangeIndexVariation.scss');
const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const { parseSpanishNumberToFloat } = require('utilities/currencyHelper');

class StockExchangeIndexVariation extends React.Component {
    checkVariationType() {
        const { variationPts } = this.props;
        // @note: Convert VariationPts in float format to check if it's greater than zero
        const variationFloat = parseFloat(variationPts.replace(',', '.'));

        if (variationFloat < 0) {
            return 'down';
        } else if (variationFloat > 0) {
            return 'up';
        } else {
            return '';
        }
    }

    showVariation(plusOrLessPts, variationPts, plusOrLessPercentage, variationPerc, currencySymbol) {
        return (
            <span>
                {plusOrLessPts}{variationPts} {currencySymbol} | {plusOrLessPercentage}{variationPerc}%
            </span>
        );
    }

    render() {
        const { variationPts, variationPerc, size, arrowCustomClassName, currencySymbol } = this.props;
        const variationType = this.checkVariationType();
        const plusSymbol = '+';

        const variationIconClassName = classNames('stock-exchange-index-variation__arrow', {
            'icon-alza': variationType === 'up',
            'icon-baja': variationType === 'down',
            'stock-exchange-index-variation__arrow--up': variationType === 'up',
            'stock-exchange-index-variation__arrow--down': variationType === 'down'
        });
        const variationClassName = classNames('stock-exchange-index-variation', {
            'stock-exchange-index-variation--small': size === 'small'
        });
        const variationParsedPercentage = parseSpanishNumberToFloat(variationPerc);
        const plusOrLessPts = variationType === 'up' ? plusSymbol : '';
        const plusOrLessPercentage = variationParsedPercentage > 0 ? plusSymbol : '';

        return (
            <div className={variationClassName}>
                <span className={arrowCustomClassName + ' stock-exchange-index-variation__arrow'}>
                    <i className={variationIconClassName} />
                </span>
                {this.showVariation(plusOrLessPts, variationPts, plusOrLessPercentage, variationPerc, currencySymbol)}
            </div>
        );
    }
}

StockExchangeIndexVariation.propTypes = {
    arrowCustomClassName: PropTypes.string,
    size: PropTypes.oneOf(['medium', 'small']),
    variationPts: PropTypes.string,
    variationPerc: PropTypes.string,
    currencySymbol: PropTypes.string
};

StockExchangeIndexVariation.defaultProps = {
    size: 'medium',
    arrowCustomClassName: ''
};

module.exports = StockExchangeIndexVariation;
